var _style, _polygon, _path, _polygon2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditPasswordImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 160",
    style: {
      enableBackground: "new 0 0 160 160"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F1C391;}\n\t.st1{fill:#313236;}\n\t.st2{fill:none;stroke:#9E9E9E;stroke-miterlimit:10;}\n\t.st3{fill:#BE2727;}\n\t.st4{fill:#000333;}\n\t.st5{fill:#383644;}\n\t.st6{fill:#FDFDFF;}\n\t.st7{fill:#D11414;}\n\t.st8{fill:#353535;}\n\t.st9{fill:#E2B68A;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "19.136,140.735 16.803,144.599 22.39,150.013 26.903,149.816 26.638,148.138 26.613,142.604 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.084,142.297c0.548,0.195,1.808,0.835,1.606,2.562c0,0,0.136,2.391,3.981,1.583c0,0,2.163-0.511,2.946-0.35 c0,0,2.926,5.787,5.359,7.546c0,0,1.829,1.387,3.671,2.368c1.842,0.981,0.426,3.021-0.053,3.385c0,0-2.508,0.678-8.921-2.514 s-12.257-6.478-13.463-6.921c0,0-0.065-0.782,0.803-1.479c0,0,0.41-3.545,3.628-6.101C17.765,142.278,17.936,142.245,18.084,142.297 z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "37.437,148.312 37.558,152.515 45.191,154.019 48.872,151.399 48.726,149.534 44.118,144.96 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.259,149.99c0,0,2.231-0.867,3.321,1.338c0,0,1.572,2.148,4.671-0.93c0,0,1.709-1.784,2.536-2.108 c0,0,6.228,3.629,9.562,3.799c0,0,2.545,0.188,4.856-0.011s2.224,2.56,1.997,3.189c0,0-1.929,2.149-9.842,3.049 S39.011,159.684,37.618,160c0,0-0.534-0.69-0.146-1.865C37.472,158.135,35.64,154.436,37.259,149.99z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M136.139,45.107H75.859c-3.443,0-6.234-2.791-6.234-6.234v0c0-3.443,2.791-6.234,6.234-6.234h60.281 c3.443,0,6.234,2.791,6.234,6.234v0C142.373,42.316,139.582,45.107,136.139,45.107z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.675,27.876c0,0-1.097,0.643-0.832,2.723c0.265,2.08,0.719,3.593,0.719,3.593L30.653,29.2 c0,0,0.605-4.841,0.945-6.202c0.34-1.361,0.227-3.668,0.227-3.668l4.462,2.345l2.723,4.5L40.675,27.876z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M41.419,35.2c0,0.076,0.857,0.303,0.857,0.303s-0.151,1.261-0.252,1.84l0.58,0.227l0.933,3.504l-3.807-4.059 L41.419,35.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M29.863,71.677c0,0-5.446,4.387-1.891,20.043l1.034,20.043l-11.002,29.016l7.866,4.122l17.254-33.541 L36.67,68.198L29.863,71.677z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.175,12.787c0,0,1.059,9.454-1.437,14.749c0,0-0.454,1.135-1.74,1.361 c-1.286,0.227-7.387-0.958-10.185-4.286l-1.235-12.354l8.093-3.706l5.521,2.118L45.175,12.787z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M40.763,12.132c0,0,2.897,0.655,4.412,0.655c0.165,0,1.384-0.856,2.301-2.654 c0.688-1.349,0.136-3.029-1.207-3.729c-2.411-1.256-6.716-2.767-11.615-1.128c-0.046,0.016-0.086,0.031-0.131,0.051 c-0.631,0.285-5.827,2.744-6.998,6.897c-0.035,0.124-0.048,0.248-0.041,0.377c0.051,1.046,0.423,6.211,2.905,11.829 c0.323,0.731,1.285,0.907,1.83,0.324c0.436-0.466,0.881-1.061,1.123-1.73c0.082-0.225,0.064-0.473-0.018-0.698 c-0.391-1.073-1.437-4.428,0.456-5.163c0.171-0.066,0.364-0.087,0.545-0.055c0.534,0.094,1.484,0.615,1.319,3.167 c0,0,0.151,1.135,1.059,0.719c0,0,0.241-4.578,0.756-5.59c0.047-0.093,0.118-0.162,0.194-0.234c0.252-0.236,0.864-0.776,1.402-1 c0.298-0.124,0.56-0.325,0.682-0.624C39.975,12.962,40.388,12.107,40.763,12.132z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M105.126,0c0,0,5.64,4.589,11.355,5.966v9.345c0,0,0.885,6.842-11.355,14.351 c-12.24-7.509-11.355-14.351-11.355-14.351V5.966C99.486,4.589,105.126,0,105.126,0z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 105.126,
    cy: 15.746,
    r: 5.497
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 105.126,
    cy: 14.405,
    r: 1.296
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.568,
    y: 15.078,
    className: "st5",
    width: 1.117,
    height: 4.57
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M26.418,77.757c0,0-0.908,8.774,3.227,17.345c0,0,4.488,17.295,5.093,22.741c0,0-0.045,23.776,0.12,29.658 c0.013,0.476,0.404,0.846,0.88,0.833c2.126-0.058,7.705-0.349,10.446-1.801l3.832-31.565l-1.588-36.909 C48.427,78.059,33.679,70.496,26.418,77.757z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M29.443,30.864c0,0-5.294,2.874-3.479,19.665c0,0,2.42,14.673,0.454,27.228c0,0,9.379,3.933,22.01,0.303 c0,0-1.21-18.455-1.513-20.421c0,0,0.605-7.412-0.227-11.043c0,0-3.328-7.715-6.605-10.841l-8.37-5.748L29.443,30.864z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.443,30.864c0,0,5.446,1.135,11.118,6.24l1.361-1.853c0,0-6.24-6.429-11.307-7.45L29.443,30.864z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 83.619,
    cy: 38.873,
    r: 2.553
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 92.577,
    cy: 38.873,
    r: 2.553
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 101.534,
    cy: 38.873,
    r: 2.553
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 110.492,
    cy: 38.873,
    r: 2.553
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 119.449,
    cy: 38.873,
    r: 2.553
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 128.407,
    cy: 38.873,
    r: 2.553
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M83.043,45.032c0,0,8.613-4.686,10.983-5.14c0,0,0.826,0,1.229,0.303s-0.816,1.762-3.085,3.022 c0,0,0.191,2.224-0.341,4.867c-0.123,0.612-0.401,1.177-0.842,1.619c-0.923,0.925-3.305,2.281-7.503,2.64L83.043,45.032z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M41.242,40.545c0,0,7.664,3.328,20.774,11.698c0,0,10.34-4.136,21.776-7.834 c0.207-0.067,0.423,0.075,0.434,0.293c0.062,1.202,0.211,4.72,0.006,7.563c-0.017,0.242-0.154,0.452-0.366,0.572 c-2.411,1.362-17.15,9.661-22.484,11.983c-0.663,0.289-1.413,0.257-2.052-0.083c-4.009-2.129-19.319-10.282-25.15-13.657 c-0.734-0.425-1.219-1.167-1.303-2.011c-0.215-2.159-0.203-6.284,2.718-7.818C39.629,39.133,41.242,40.545,41.242,40.545z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPasswordImg);
export default __webpack_public_path__ + "static/media/editPasswordImg.be84d31de77933a0e44ddb24ead7d652.svg";
export { ForwardRef as ReactComponent };